import { measure, noop } from "@sail/utils";
import { useCallback } from "react";
// NB! `loadBundle` function can be invoked more than once for a given bundle:
// 1) when prefetching a bundle and 2) then when rendering it, but the second step should essentially
// be a no-op, since JS bundles are guaranteed to be loaded only once, because the `require.ensure()` function
// that Webpack uses internally is idempotent, that is, Webpack guarantees that the requested bundle is loaded
// only once. So in order to prevent double-reporting and to capture the `prefetch.async_bundle.${id}` metric
// only when JS bundles are really loaded, we maintain this set of already loaded bundle load fns.
const alreadyLoadedBundles = new Set();
export default function usePrefetchBundles() {
    const loadBundle = useCallback((loadFn)=>{
        const start = performance.now();
        return loadFn().then(noop).finally(()=>{
            if (!alreadyLoadedBundles.has(loadFn)) {
                measure(`prefetch.async_bundle.${loadFn.name}`, {
                    start,
                    end: performance.now()
                });
                alreadyLoadedBundles.add(loadFn);
            }
        });
    }, []);
    return useCallback(function prefetchBundles(loadFns) {
        return Promise.all(loadFns.map((loadFn)=>{
            return loadBundle(loadFn).then((value)=>({
                    status: 'fulfilled',
                    value
                })).catch((reason)=>({
                    status: 'rejected',
                    reason
                }));
        }));
    }, [
        loadBundle
    ]);
}

//# sourceMappingURL=usePrefetchBundles.js.map